<template>
  <div>
    <H5ActivityView
      class="mall-h5-activity-view"
      :class="[bottomClassName]"
      :options="data"
      :customWidgets="customWidgets"
    ></H5ActivityView>
  </div>
</template>

<script>
import { H5ActivityView, pubSub } from '@igetcool/cool-mobile-ui';
import customWidgets from './custom.config.js';

export default {
  components: { H5ActivityView },
  props: {
    data: {
      type: Object
    },
    localWidgets: {
      type: Array,
      default: () => []
    },
  },
  data() {
    return {
    };
  },
  computed: {
    bottomClassName() {
      return this.$route.name;
    },
    customWidgets() {
      return [...customWidgets, ...this.localWidgets];
    }
  }

};
</script>

<style lang="stylus" scoped>
.mall-h5-activity-view {
  &.courseItem {
    /deep/ .cool-special-bottom_wrap {
      bottom: calc(0.64rem + env(safe-area-inset-bottom));
    }
  }
}
</style>